import React from 'react';
// import NavBar from '../../components/common/navbar';
// import SideBar from '../../components/modules/left_sidebar';
import CreateUserComponent from '../../components/UserList/CreateUser/create_user_component';
// import FormNavbar from '../../components/common/wizard_navbar';
// import FormleftNev from '../../components/common/FormleftNev';
const InputFieldsAll = {
  PersonalDetails: [
    {
      key: 'FullName',
      type: 'text',
      display: 'Full Name',
      required : false
    },
    {
      key: 'DisplayName',
      type: 'text',
      display: 'Abreviatura',
      required : false
    },
    // {
    //   key: 'DOB',
    //   type: 'date',
    //   display: 'DOB',
    //   required : false
    // },
    {
      key: 'status',
      type: 'dropdown',
      display: 'Estado de utilizador',
      required : false,
      dropdownData: {
        1: 'Ativo',
        2: 'Inativo'
      }
    }

  ],
  Contatos: [
    {
      key: 'Email',
      type: 'text',
      display: 'Email',
      required : false
    },
    {
      key: 'ContactNumber',
      type: 'number',
      display: 'Contact Number',
      required : false
    },

  ],
  OtherDetails: [
    {
      key: 'Username',
      type: 'text',
      display: 'Nome de Utilizador',
      required : false
    },
    {
      key: 'Password',
      type: 'password',
      display: 'Password',
      required : false
    },
    {
      key: 'designation',
      type: 'dropdown',
      display: 'Designation',
      required : false
    },
    {
        key: "Notes",
        type: "textarea",
        display: "Notes",
        required : false
    },

  ]

};

class CreateUserPage extends React.Component {
  render() {
    const topBarMenu = this.props.location && this.props.location.state && this.props.location.state.topBarMenu;
    return (
      <CreateUserComponent topBarMenuOption={topBarMenu} {...this.props} InputFieldsAll={InputFieldsAll} />
    );
  }
}

export default CreateUserPage;
